export interface Toast {
  id: number;
  text: string;
}

const STAY_MS = 3500;

/**
 * A short word that a saved thing was saved (ADR-060). Only for success: a failure stays beside the
 * form that failed, where it can be fixed. Never takes focus, and never carries a client's name
 * (DiagBar and screenshots see it too).
 */
class Toasts {
  items = $state<Toast[]>([]);
  #next = 0;

  success(text: string) {
    this.#next += 1;
    const id = this.#next;
    this.items.push({ id, text });
    setTimeout(() => this.dismiss(id), STAY_MS);
  }

  dismiss(id: number) {
    this.items = this.items.filter((t) => t.id !== id);
  }
}

export const toast = new Toasts();
